// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__E1_N2","savePackageButton":"ClientWallet_savePackageButton__3QVox"};